export default [
  {
    path: 'inventory',
    name: 'inventory',
    component: () => import('@/views/at/Wrapper'),
    children: [
      {
        path: '',
        name: 'inventory',
        component: () => import('@/views/inventory/Menu.vue'),
      },
      {
        path: 'equipment-maintenance',
        name: 'equipmentMaintenance',
        component: () =>
          import('@/views/inventory/equipmentMaintenance/Main.vue'),
      },
      {
        path: 'equipment-maintenance/inventory-management/:id',
        name: 'inventoryManagement',
        component: () =>
          import(
            '@/views/inventory/equipmentMaintenance/inventoryManagement/Main.vue'
          ),
      },
      {
        path: 'equipment-maintenance/inventory-management/:id/maintenance',
        name: 'inventoryMaintenance',
        component: () =>
          import(
            '@/views/inventory/equipmentMaintenance/inventoryManagement/components/InventoryMaintenance.vue'
          ),
      },
      {
        path:
          'equipment-maintenance/inventory-management/:id/details/:equipmentId',
        name: 'inventoryMaintenanceEquipmentDetails',
        component: () =>
          import(
            '@/views/inventory/equipmentMaintenance/equipementDetails/Main.vue'
          ),
      },
      {
        path:
          'equipment-maintenance/inventory-management/:id/edit/:equipmentId',
        name: 'inventoryMaintenanceEquipmentEdit',
        component: () =>
          import('@/views/inventory/equipmentMaintenance/edit/Main.vue'),
      },
      {
        path: 'equipment-maintenance/inventory-management/:id/add/:equipmentId',
        name: 'inventoryMaintenanceEquipmentAddInventory',
        component: () =>
          import(
            '@/views/inventory/equipmentMaintenance/edit/AddInventory.vue'
          ),
      },
      {
        path: 'equipmenttranfer/requesthandling',
        name: 'equipmentTranferRequestHandling',
        component: () =>
          import('@/views/inventory/equipmentTranferRequestHandling/Main.vue'),
      },
    ],
  },
];
